export default __webpack_public_path__ + "9cedd55d88f96c60b487816d8e16b6ad.svg";